<template>
  <div>
    <StepHeader title="Do You Rent or Own Your Home?"/>

    <StepContent
      width="lg"
    >
      <AppButtonList
        :columns="2"
        :buttons="buttons"
        flex-row
        label="Please Select"
        :value="rent_own"
        class="button-list"
        gapless
        @input="defaultSelected = false; handleInput('rent_own', $event)"
      />
      <AppInput
        label="Monthly Payment"
        hint="Round to Nearest Dollar"
        type="tel"
        pattern="\d*"
        name="rent_payment"
        :value="rentPayment"
        :error="rentPaymentError"
        v-data-layer
        icon
        class="app-input"
        data-layer="rent_payment_field"
        @input="handleInput('rent_payment', $event)"
      >
        <span slot="icon">$</span>
      </AppInput>
    </StepContent>
    <!-- :error="error" -->

    <StepFooter>
      <AppButtonContinue
        v-data-layer="handleDataLayer"
        @click="handleContinue()"
      >
        Continue
      </AppButtonContinue>

      <StepTooltip>
        If you share a mortgage or rent payment with someone else only include the amount you pay every month.
      </StepTooltip>
    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import AppInput from '../inputs/AppInput'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepTooltip from '@/components/common/step/StepTooltip'
import DataLayer from '../../../../data-layer'

export default {
  // Name
  name: 'address-rent-own',

  // Components
  components: {
    AppButtonContinue,
    AppButtonList,
    AppInput,
    StepContent,
    StepFooter,
    StepHeader,
    StepTooltip
  },

  // Data
  data () {
    return {
      datalayerStepName: 'address_details',
      fieldName: 'rent_own',
      defaultSelected: true,
      submitted: false,
      buttons: [{
        text: 'Rent',
        value: 'Rent',
        datalayer: 'rent'
      }, {
        text: 'Own',
        value: 'Own',
        datalayer: 'own'
      }],
      errors: {
        isRequired: 'Required.',
        invalidNumber: 'Invalid number.'
      }
    }
  },

  // Computed
  computed: {
    isValidNumber () {
      if (parseFloat(this.rentPayment) > 999999999) return false
      return /^\d+$/.test(this.rentPayment)
    },

    rent_own () {
      return this.$store.state.application.rent_own
    },

    rentPayment () {
      return this.$store.state.application.rent_payment
    },

    rentPaymentError () {
      if (!this.submitted) return
      if (!this.rentPayment) return this.errors.isRequired
      if (!this.isValidNumber) return this.errors.invalidNumber
    },

    selectedButton () {
      if (!this[this.fieldName]) return
      for (let i in this.buttons) {
        if (this.buttons[i].value === this[this.fieldName]) {
          return this.buttons[i]
        }
      }
    },

    datalayerButtonList () {
      if (!this.selectedButton) return
      const datalayer = this.selectedButton.datalayer
      return `${this.datalayerStepName}_${datalayer}${this.defaultSelected ? '_default' : ''}`
    },

    stepIsValid () {
      return !this.rentPaymentError
    }
  },

  mounted () {
    if (!this[this.fieldName]) {
      this.defaultSelected = true
      this.handleInput('rent_own', this.buttons[0].value)
    }
  },

  // Methods
  methods: {
    /**
     * Handle Input
     * Update the store
     */
    handleInput (field, event) {
      this.$store.updateApplication(field, event)
    },

    /**
     * Handle Continue
     * Validate the step and continue
     */
    async handleContinue () {
      this.submitted = true
      if (!this.rentPaymentError) {
        this.$emit('next')
      }
    },

    handleDataLayer () {
      DataLayer.track({
        event: 'gpa_step_completed',
        step: '13',
        home_situation: this.rent_own
      })
    }
  }
}
</script>

<style scoped lang="scss">
.button-list, .app-input {
  flex-basis: 50%;
}

.button-list {
  margin-bottom: 20px;

  @include breakpoint('tablet-landscape-up') {
    margin-bottom: 50px;
  }
}
</style>
